<template>
  <div>
    <v-autocomplete
      v-model="serviceProviderID"
      :items="getServiceProviders"
      @change="emitServiceProviderID()"
      item-text="name"
      item-value="id"
      dense
      label="Select Service Provider"
    ></v-autocomplete>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getServiceProviders() {
      return this.$store.getters.getServiceProviders;
    }
  },
  mounted() {
    axios
      .getData("/auth/get-all-service-providers", this.getAccessToken)
      .then(serviceProviders => {
        this.$store.commit("setServiceProviders", serviceProviders);
      });
  },
  data: () => ({
    serviceProviderID: null
  }),
  methods: {
    emitServiceProviderID() {
      this.$emit("service-provider-selected", this.serviceProviderID);
    }
  }
};
</script>

<style>
</style>